<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>Wholesale Management</v-toolbar-title>
      <v-spacer />
      <v-text-field
        v-if="authPermissions.has('whole_sales:view')"
        v-model="search"
        append-icon="mdi-magnify"
        dense
        hide-details
        placeholder="Search..."
        style="max-width: 300px"
        @input="reload"
      />
    </v-toolbar>

    <v-row class="mt-4">
      <v-col v-if="authPermissions.has('whole_sales:create')" cols="6">
        <create-whole-sale @created="reload" />
      </v-col>

      <v-col v-if="authPermissions.has('whole_sales:view')" cols="6">
        <index-whole-sale
          ref="indexWholeSaleRef"
          :search="search"
          @delete="deleteWholeSale"
          @sync-stocks="onSyncStocks"
          @edit="openEdit"
        />
      </v-col>
    </v-row>
    <v-dialog v-model="editDialog" eager width="800">
      <edit-whole-sale
        ref="editWholeSale"
        @close="editDialog = false"
        @updated="reload"
      />
    </v-dialog>
    <sync-stocks ref="syncStocksRef" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import {
  ErrorPopup,
  LoadingPopup,
  SuccessPopup,
  useWatchEffect,
} from '../../../../lib/utils'
import { authAxios } from '@/extra-functions/axios.extra'

const [watchEffect] = useWatchEffect()

export default {
  name: 'WholesalePage',
  components: {
    CreateWholeSale: () => import('./Create.vue'),
    EditWholeSale: () => import('./Edit.vue'),
    IndexWholeSale: () => import('./Index.vue'),
    SyncStocks: () => import('./SyncStocks.vue'),
  },
  data() {
    return {
      search: '',
      refreshKey: 0,
      editDialog: false,
    }
  },
  computed: {
    ...mapState({
      authPermissions: (state) => state.auth.userPermissions,
    }),
  },
  methods: {
    async deleteWholeSale(item) {
      try {
        const confirm = await this.$confirm(
          `Deleting ${item.name}: do you wish to process?`,
        )
        if (!confirm) return
        LoadingPopup.fire(
          'Loading',
          'Please wait while the whole sale is being removed',
        )
        const { data } = await authAxios().delete(`/whole-sales/${item.id}`)
        SuccessPopup.fire('Success', data)
        this.reload()
      } catch (e) {
        if (e instanceof Error) console.error(e.message)
        ErrorPopup.fire()
      }
    },
    reload() {
      watchEffect((onCleanup) => {
        const controller = new AbortController()
        onCleanup(() => {
          controller.abort()
        })
        this.$refs?.indexWholeSaleRef?.fetch?.(controller)
      }, 'indexWholeSaleRefFetch')
    },
    openEdit(data) {
      if (this.authPermissions.has('whole_sales:edit')) {
        this.$refs.editWholeSale.populate(data)
        this.editDialog = true
      }
    },
    onSyncStocks(wholeSaleId) {
      console.log('Syncing stocks for whole sale ID:', wholeSaleId)
      this.$refs.syncStocksRef?.openDialog?.(wholeSaleId)
    },
  },
}
</script>
